module.exports = __webpack_public_path__ + "img/search_focus_b.deb0859.png";